import { render, staticRenderFns } from "./OverviewSearchResultsList.vue?vue&type=template&id=53465272&scoped=true&"
import script from "./OverviewSearchResultsList.vue?vue&type=script&lang=js&"
export * from "./OverviewSearchResultsList.vue?vue&type=script&lang=js&"
import style0 from "./OverviewSearchResultsList.vue?vue&type=style&index=0&id=53465272&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53465272",
  null
  
)

export default component.exports